module.exports = __webpack_public_path__ + "img/dell-inspirion.bc37f388.jpg";